import React from "react";
import Audio from "./Audio";

const AudioContainer = props => {
  const {
    elementData,
    isPlaying,
    isPaused,
    currentPlayingTime,
    pageData,
    pageId,
    currentPageId
  } = props;

  // Audio elements are invisible and only handle playback
  return (
    <Audio
      elementData={elementData}
      isPlaying={isPlaying}
      isPaused={isPaused}
      currentPlayingTime={currentPlayingTime}
      pageData={pageData}
      pageId={pageId}
      currentPageId={currentPageId}
    />
  );
};

export default AudioContainer;
